  document.addEventListener("DOMContentLoaded", function () {
    const tabButtons = document.querySelectorAll(".tab-title");
    const tabContents = document.querySelectorAll(".accordion-container");
    tabButtons.forEach((button) => {
        button.addEventListener("click", function () {
            tabButtons.forEach(btn => btn.classList.remove("active-tab"));
            tabContents.forEach(content => content.classList.remove("active-tab-content"));
            this.classList.add("active-tab");
            const targetTab = this.getAttribute("data-tab");
            document.querySelector(`[questionsdata-tab-content="${targetTab}"]`).classList.add("active-tab-content");
        });
    });
});